<template>
    <v-container class="content-container">
        <v-sheet
            color="grey lighten-4"
            class="rounded-16"
            :class="!isMobilePort ? 'pa-7 pb-0 mt-9' : 'pa-6 mt-0' ">
            <v-row dense justify="center">
                <v-col cols="12" md="8">
                    <h3 
                        class="font-weight-medium" 
                        :class="!isMobilePort ? 'text-h3' : ''" 
                        style="line-height: 150%;" 
                        :style="isMobilePort ? `font-size: 32px` : ''">
                        <span class="primary--text">Your trusted source</span> for building<br>
                        codes, standards and more
                    </h3>
                    <h6 
                        class="font-weight-regular pt-6"
                        :class="!isMobilePort ? 'text-h6' : ''"
                        :style="isMobilePort ? `font-size: 16px` : ''">
                        From the International Code Council, Digital Codes is the most authoritative
                        database
                        of model codes, standards and supplements.
                    </h6>
                </v-col>
                <v-col cols="12" md="4" class="text-center pb-0">
                    <v-img :src="this.asset(require('../../../app/images/homepage/home-header-image.png'))"
                        alt="Building codes, standards and more" contain>
                    </v-img>
                </v-col>
            </v-row>
        </v-sheet>
    </v-container>
</template>
<script>
import Mobile from '../inc/mixins/mobile';

export default {
    mixins: [Mobile],
};
</script>